import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { TextField, makeStyles } from "@material-ui/core";
import {
  selectTelephone,
  selectTelephoneCountryCode,
  set,
} from "./telephoneSlice";

import { selectLanguage } from "../language/languageSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
      "&:hover": {
        boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
      },
      transition: "box-shadow 0.75s",
    },
  },
}));

export function Telephone() {
  const classes = useStyles();
  const telephoneValue = useSelector(selectTelephone);
  const countryCodeValue = useSelector(selectTelephoneCountryCode);
  const language = useSelector(selectLanguage);
  const dispatch = useDispatch();
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <TextField
        required
        color="secondary"
        id="input-telephone"
        label={
          language !== undefined
            ? language === "TH"
              ? "โทรศัพท์"
              : "Mobile Phone"
            : "Mobile Phone"
        }
        placeholder={
          language !== undefined
            ? language === "TH"
              ? "เบอร์โทรศัพท์"
              : "please fill telephone number "
            : "please fill telephone number "
        }
        multiline
        type="number"
        value={
          (countryCodeValue || "") +
          (countryCodeValue === "+66 " && telephoneValue.length > 0
            ? telephoneValue[0].replace(/^0/, "")
            : telephoneValue)
        }
        variant="outlined"
        onChange={(e) => {
          if (countryCodeValue.length > 0) {
            if (e.target.value.length <= 20) {
              let text =
                /\d+/.exec(
                  e.target.value.substring(
                    countryCodeValue.length,
                    21 - countryCodeValue.length
                  )
                ) || "";
              dispatch(set(text));
            }
          } else {
            if (e.target.value.length <= 20) {
              dispatch(set(/\d+/.exec(e.target.value) || ""));
            }
          }
        }}
      />{" "}
    </form>
  );
}
